export default {
  dbu_year_report_title: '2025年度回顾',
  dbu_year_report_menu_title: '2025年度回顾',
  dbu_year_report_loading: '加载中...',
  dbu_year_report_load_error: '页面加载失败，请稍后重试',
};
